import ROUTES from '../Routing/Routes';
import { Item, ItemTypeEnum } from '../Rest/Services/Data';

// The API serializes enums as strings ("Merchandise"), while locally created cart items use the numeric enum.
export const isMerchandiseItem = (item: Pick<Item, 'type'>) =>
  item.type === ItemTypeEnum.Merch || (item.type as unknown) === 'Merchandise';

export const getItemLink = (item: Pick<Item, 'id' | 'type'>) =>
  isMerchandiseItem(item) ? `${ROUTES.SHOP}/${item.id}` : `${ROUTES.DETAILS}/${item.id}`;
